import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  const { isLoggedIn } = useSelector((state) => state.login || {});

  return (isLoggedIn && token) ? children : <Navigate to="/login" replace />;
}
